// ============================================================
// useGuidelineFavorites.js — 보고서 원칙 즐겨찾기 훅
// ============================================================
// 역할: 사용자가 별표(⭐)를 누른 원칙의 id 배열을 localStorage에
//       저장하고, GuidelinesDashboard에서 '즐겨찾기 보기'에 활용합니다.
//
// 비유: 책에 포스트잇을 붙여 나중에 바로 찾아볼 수 있게 하는 것과 같아요.
// ============================================================

import { useState, useCallback } from 'react';

// 기존 report_copilot_favorites 키와 겹치지 않도록 별도 키 사용
const STORAGE_KEY = 'guideline_principle_favorites';

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    // 저장된 값이 있으면 파싱해서 Set으로 변환, 없으면 빈 Set
    return raw ? new Set(JSON.parse(raw)) : new Set();
  } catch {
    return new Set();
  }
}

function persist(set) {
  try {
    // Set은 JSON으로 직접 저장 불가 → 배열로 변환 후 저장
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
  } catch {
    console.warn('즐겨찾기 저장 실패');
  }
}

export function useGuidelineFavorites() {
  // 즐겨찾기된 원칙 id의 Set
  const [favSet, setFavSet] = useState(() => load());

  // 추가/제거 토글
  const toggle = useCallback((id) => {
    setFavSet((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id); // 이미 있으면 제거
      } else {
        next.add(id);    // 없으면 추가
      }
      persist(next);
      return next;
    });
  }, []);

  // 특정 id가 즐겨찾기인지 확인
  const isFav = useCallback((id) => favSet.has(id), [favSet]);

  return { favSet, toggle, isFav, count: favSet.size };
}
